const productTypeGroupSelectOptions = [
  { value: 'not-selected', label: 'Not selected' },
  { value: 'poster_binding', label: 'Poster bindings' },
];

export default productTypeGroupSelectOptions;
